import { PropsWithChildren, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../../nav/NavBar';
import SideBar from '../../nav/SideBar';

export default function AdminLayout({ children }: PropsWithChildren) {
  const [showToolbar, setShowToolbar] = useState<boolean>(true);
  const dontShowToolbarArr = ['/signin', '/forgot-password', '/reset-password', '/register'];
  const location = useLocation();

  useEffect(() => {
    if (dontShowToolbarArr.includes(location.pathname)) {
      setShowToolbar(false);
    } else {
      setShowToolbar(true);
    }
  }, [location.pathname]);

  return (
    <>
      {showToolbar && (
        <div className="flex">
          <SideBar />
          <div className="flex-1 overflow-x-hidden">
            <NavBar />
            <div className="mx-auto flex py-8 px-4">
              <div className="w-full space-y-8">{children}</div>
            </div>
          </div>
        </div>
      )}
      {!showToolbar && (
        <div className="flex">
          <div className="flex-1">
            <div className="mx-auto flex">
              <div className="w-full space-y-8">{children}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
